module.exports = __webpack_public_path__ + "static/media/prize-mtn-retro.c8845e54.png";